
import { Link } from 'react-router-dom';

export default function ResourceCTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-[#e10708] via-[#c00607] to-[#a00506]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 right-20 w-64 h-64 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 left-20 w-80 h-80 bg-white rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full mb-8">
            <i className="ri-customer-service-2-line text-4xl text-white"></i>
          </div>

          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Let's Start Planning Your Practice Together
          </h2>
          
          <p className="text-xl text-red-50 mb-10 max-w-2xl mx-auto leading-relaxed">
            Schedule a consultation to discuss your practice startup or growth plans. We'll help you navigate technology decisions with confidence.
          </p>

          <Link
            to="/contact"
            className="inline-block bg-white text-[#e10708] px-12 py-5 rounded-lg text-xl font-bold hover:bg-gray-50 transition-all duration-300 shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Schedule Your Assessment
          </Link>

          <div className="mt-12 flex flex-wrap justify-center gap-8 text-white/90">
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-xl"></i>
              <span className="text-sm">Free Consultation</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-xl"></i>
              <span className="text-sm">HIPAA Experts</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-hospital-line text-xl"></i>
              <span className="text-sm">Healthcare Specialized</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}